// extracted by mini-css-extract-plugin
module.exports = {"icon":"AssessmentAndAssignmentList_icon__LKiUx"};